export default "__VITE_ASSET__2ClJQInomgWWHzlG3IFhuA__"